import React from 'react';
import '../css/footer.css';

function FormEditInput(props){
    
    //const [unionLaboral, setUnionLaboral] = useState([]); 
    
    function corregido(id){

        const elem = document.getElementById(id);
        if(elem.classList.contains("texBoxError"))
            elem.classList.remove("texBoxError");
    }  
    
    /*useEffect(() => {
        if(props.idSeccion === 0){
        axios
            .get(process.env.REACT_APP_URL + 'empresa/getAllUnionesIndustriales')
            .then(function (response) { 
                setUnionLaboral(response.data.filter(union => union !== "Todas"));
            })
            .catch(function (error) {
                console.log(error);
                //return toast.error("Error al cargar las uniones, inténtelo más tarde");
            });
        }
    }, []);*/
    
    return(  
        props.idSeccion === undefined?
            <div className={props.className}>
                <div className='col-3 col-md-2'>
                    <p className=' py-3 mb-0'>
                        <span className='tituloDatoPerfil'>{props.text}</span> 
                        <div id={props.idSeccion + "Helper"} class={"form-text textoErrores " + (props.helper? 'd-inline':'')}>{props.helper}</div>
                    </p>
                </div>
                <div className='col-9 col-sm'>
                    <input type={props.type} onChange={()=>corregido(props.id)} class="form-control letraDatos" id={props.id} defaultValue={props.defaultValue}/>
                </div>
            </div>   
        :props.idSeccion === 0?
            <>
                <div className='col-3 col-md-2'>
                    <p className=' py-3 mb-0'>
                        <span className='tituloDatoPerfil'>{props.text}</span> 
                    </p>
                </div>
                <div className='col-9 col-md'>
                    <input type={props.type} onChange={()=>corregido(props.id)} class="form-control letraDatos" id={props.id} defaultValue={props.defaultValue}/>
                </div>
            </>
        :props.idSeccion === 1?
        <>
            <div className={props.className}>
                <textarea onChange={()=>corregido(props.id)}  class="form-control formDescripcion letraDatos" id={props.id} rows="3" defaultValue={props.defaultValue}>
                </textarea>
            </div>
        </>
        :
        <>
        </>
        
    );
}


export default FormEditInput;